import { Deserializable } from './deserializable.model';
import {JsonProperty} from 'json-typescript-mapper';

export class Image implements Deserializable {
  @JsonProperty('url')
  url?: string;
  @JsonProperty('imageWidth')
  imageWidth?: number;
  @JsonProperty('imageHeight')
  imageHeight?: number;
  @JsonProperty('alt')
  alt?: string;
  @JsonProperty('data')
  data?: string;

  constructor() {
    this.url = void 0;
    this.imageWidth = void 0;
    this.imageHeight = void 0;
    this.alt = void 0;
    this.data = void 0;
  }


  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/image.model.ts